<template lang="pug">
  #section1s1
    .container-fluid
      .row.content.d-flex.align-items-center
        .col-md-5.right.pl-0
          img.back-img(src="/assets/img/microsite/PrivilegioSalud_Desktop.png")
        .col-12.top.p-0
          img.back-img(src="/assets/img/microsite/PrivilegioSalud_Mobile.png")
        .col-11.col-sm-10.col-md-7.text.px-4.d-flex
          p.sub-title.default-text.text-bold
            span.text-white El privilegio&nbsp;
            span de la salud
          p.subtext.default-text.bold Sabemos que la obesidad, la diabetes y la hipertensión son enfermedades que aumentan la probabilidad de que el COVID empeore, pero ¿cómo puede relacionarse nuestro género, escolaridad o nivel socioeconómico con la probabilidad de desarrollar diabetes, hipertensión u obesidad? En este artículo contestamos esa pregunta.
          router-link.story-btn.text-white(to="/la-amenaza-privilegio") Leer Blog
</template>

<script>
export default {
  name: "Section2s1"
};
</script>

<style lang="scss">
#section1s1 {
  min-height: 100vh;
  padding: 1rem 0;
  margin-bottom: 10rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 300px;
    }
  }
  .content {
    min-height: 654px;
    background-image: url("/assets/img/microsite/Oval_Desktop.svg");
    background-size: cover;
    //text-align: center;
    justify-content: center;
    align-items: flex-end;
    .right {
      align-self: center;
      display: block;
      .back-img {
        width: 100%;
        height: auto;
        text-align: right;
      }
    }
    .top {
      display: none;
      .back-img {
        width: 100%;
      }
    }
    .text {
      min-height: 45vh;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .subtext {
        line-height: 1.75;
      }
      a {
        color: #0a1d59;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #0a1d59;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 3.5rem;
      }
      .story-btn:hover {
        background-color: #0a1d59;
        color: #fff;
      }
    }
  }
}
@media (max-width: 500px) {
  #section1s1 {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #section1s1 {
    // .title {
    //   img {
    //     width: auto;
    //     max-width: 70vw;
    //   }
    // }
    .sub-title {
      font-size: 2.2rem;
    }
    .content {
      background-image: url("/assets/img/microsite/Oval_Mobile.svg");
      padding: 2rem 0;
      align-items: flex-end;
      .text {
        .subtext {
          line-height: 1.5;
          max-width: 90%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          font-size: 1rem;
          border: solid 2px #0a1d59;
          padding: 0.5rem 2.5rem;
          margin: 0.8rem auto 0.8rem auto;
        }
      }
    }
    .right {
      display: none !important;
    }
    .top {
      display: block !important;
      top: -2rem;
      position: relative;
    }
  }
}
</style>
